import { ID } from 'shared/types/id';
import { lifeAreaOtherID } from 'shared/types/orderable-section';
import { GoalSortingMode } from 'shared/types/sorting-mode';

import { getUser, getUserRef } from './get-user';
import { updateDocWithTimestamp } from './helpers';

export const updateGoalGroupingLifeAreaGoalOrder = async (
  lifeAreaSorting: { lifeAreaId: ID; goalIds: ID[] }[],
) => {
  const user = await getUser();
  // without a user we cannot update anything.
  if (!user) {
    return;
  }

  const userRef = await getUserRef();

  if (!userRef) {
    return;
  }

  const settingsToUpdate = lifeAreaSorting.reduce<
    Record<string, ID[] | GoalSortingMode>
  >(
    (acc, { lifeAreaId, goalIds }) => {
      acc[
        `settings.goalGroupSorting.lifeArea.sorting.${lifeAreaId === lifeAreaOtherID ? null : lifeAreaId}`
      ] = goalIds;
      return acc;
    },
    {
      'settings.goalSortingMode': GoalSortingMode.Custom,
    },
  );

  updateDocWithTimestamp(userRef, settingsToUpdate);
};
